import React from 'react';
import * as FaIcons from 'react-icons/fa'
import * as AiIcons from 'react-icons/ai'
import * as IoIcons from 'react-icons/io'

export const SidebarData = [
    {
        title:'Home',
        path:'/home',
        cName:'navtext'
    },
    {
        title:'About us',
        path:'/about-us',
        cName:'navtext'
    },
    {
        title:'Web design',
        path:'/web-design',
        cName:'navtext'
    },
    {
        title:'Graphics',
        path:'/graphics',
        cName:'navtext'
    },
    {
        title:'Contacts',
        path:'/contacts',
        cName:'navtext'
    }
]